import React from 'react'

const IconBoxAdd = ({ fill = '#E4EEFB' }) => {
  return (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.45964 11.0752H7.54297V7.8252H10.793V6.74186H7.54297V3.49186H6.45964V6.74186H3.20964V7.8252H6.45964V11.0752ZM0.417969 13.8669V0.700195H13.5846V13.8669H0.417969ZM1.5013 12.7835H12.5013V1.78353H1.5013V12.7835Z'
        fill={fill}
      />
    </svg>
  )
}

export default IconBoxAdd
